/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AnyDataObjectId,
  BillableRoutingLogs,
  ConciergeRouterDraft,
  CoverUploadRequest,
  CoverUriResponse,
  EnrichmentResponse,
  ExistingRouterCoordinates,
  ExternalFlowState,
  FireMigrationSettingsResponse,
  ForeignForms,
  GetRouterBySlugResponse,
  HtmlPage,
  LaunchRouteRequest,
  LaunchRouteResponse,
  LiveChooseCallRequest,
  MapString,
  PaginatedResultRouterLogSummary,
  PaginatedResultRoutingLogHeader,
  PreLaunchResponse,
  PublicConciergeDraftWithRouter,
  PublicRoutingInfoResponse,
  RouterLogStats,
  RoutingAcceptedState,
  RoutingLog,
  RoutingLogAssignmentMethod,
  RoutingLogStatus,
  RoutingTriggerType,
  ScheduleMeetingRequest,
  ScheduleMeetingResult,
  UriContainer,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "concierge-fire";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Get useFire flag
   *
   * @tags migration
   * @name GetUseFireFlag
   * @request GET:/v1/public/tenant/{tenantId}/migration/settings
   */
  getUseFireFlag = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      FireMigrationSettingsResponse,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/migration/settings`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUseFireFlag */
  getUseFireFlagPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/migration/settings`);

  /**
   * @description Get router settings by slug
   *
   * @tags Guest, routing
   * @name SettingsBySlug
   * @request GET:/v1/guest-external/tenant/{tenantId}/router/{routerSlug}
   * @secure
   */
  settingsBySlug = (tenantId: string, routerSlug: string, params: RequestParams = {}) =>
    this.request<
      GetRouterBySlugResponse,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/router/${routerSlug}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for settingsBySlug */
  settingsBySlugPathGetter = (tenantId: string, routerSlug: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/router/${routerSlug}`);

  /**
   * @description [DEPRECATED] Enrich form data by router slug. Use prelaunchBySlug instead.
   *
   * @tags Guest, routing
   * @name EnrichFormDataByRouterSlug
   * @request GET:/v1/guest-external/tenant/{tenantId}/router/{routerSlug}/enrichment
   * @deprecated
   * @secure
   */
  enrichFormDataByRouterSlug = (
    tenantId: string,
    routerSlug: string,
    query: {
      /** @pattern .+@.+ */
      email: string;
      "trigger-type"?: RoutingTriggerType;
      "with-values"?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      EnrichmentResponse,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/router/${routerSlug}/enrichment`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for enrichFormDataByRouterSlug */
  enrichFormDataByRouterSlugPathGetter = (
    tenantId: string,
    routerSlug: string,
    query: {
      /** @pattern .+@.+ */
      email: string;
      "trigger-type"?: RoutingTriggerType;
      "with-values"?: boolean;
    },
  ) => this.getServicePath(`/v1/guest-external/tenant/${tenantId}/router/${routerSlug}/enrichment`, query);

  /**
   * @description Performs enrichment and spam checking in parallel for a router
   *
   * @tags Guest, routing
   * @name PreLaunchOperationsByRouterSlug
   * @request GET:/v1/guest-external/tenant/{tenantId}/router/{routerSlug}/prelaunch
   * @secure
   */
  preLaunchOperationsByRouterSlug = (
    tenantId: string,
    routerSlug: string,
    query: {
      /** @pattern .+@.+ */
      email: string;
      "trigger-type": RoutingTriggerType;
      /** @default false */
      "with-values"?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PreLaunchResponse,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/router/${routerSlug}/prelaunch`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for preLaunchOperationsByRouterSlug */
  preLaunchOperationsByRouterSlugPathGetter = (
    tenantId: string,
    routerSlug: string,
    query: {
      /** @pattern .+@.+ */
      email: string;
      "trigger-type": RoutingTriggerType;
      /** @default false */
      "with-values"?: boolean;
    },
  ) => this.getServicePath(`/v1/guest-external/tenant/${tenantId}/router/${routerSlug}/prelaunch`, query);

  /**
   * @description Route given form and return data needed to continue the flow
   *
   * @tags Guest, routing
   * @name LaunchRouting
   * @request POST:/v1/guest-external/tenant/{tenantId}/router/{routerSlug}/route
   * @secure
   */
  launchRouting = (tenantId: string, routerSlug: string, data: LaunchRouteRequest, params: RequestParams = {}) =>
    this.request<
      LaunchRouteResponse,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/router/${routerSlug}/route`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for launchRouting */
  launchRoutingPathGetter = (tenantId: string, routerSlug: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/router/${routerSlug}/route`);

  /**
   * @description Choose scheduling path for live routing
   *
   * @tags Guest, routing
   * @name CfLiveChooseScheduling
   * @request POST:/v1/guest-external/tenant/{tenantId}/routing/{routingId}/choose-scheduling
   * @secure
   */
  cfLiveChooseScheduling = (tenantId: string, routingId: string, data: object, params: RequestParams = {}) =>
    this.request<
      LaunchRouteResponse,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/routing/${routingId}/choose-scheduling`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for cfLiveChooseScheduling */
  cfLiveChooseSchedulingPathGetter = (tenantId: string, routingId: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/routing/${routingId}/choose-scheduling`);

  /**
   * @description Choose call path for live routing
   *
   * @tags Guest, routing
   * @name CfLiveChooseCall
   * @request POST:/v1/guest-external/tenant/{tenantId}/routing/{routingId}/choose-call
   * @secure
   */
  cfLiveChooseCall = (tenantId: string, routingId: string, data: LiveChooseCallRequest, params: RequestParams = {}) =>
    this.request<
      LaunchRouteResponse,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/routing/${routingId}/choose-call`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for cfLiveChooseCall */
  cfLiveChooseCallPathGetter = (tenantId: string, routingId: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/routing/${routingId}/choose-call`);

  /**
   * @description Check guest number for live routing
   *
   * @tags Guest, routing
   * @name CfLiveCheckGuestNumber
   * @request GET:/v1/guest-external/tenant/{tenantId}/check-guest-number/{phone}
   * @secure
   */
  cfLiveCheckGuestNumber = (tenantId: string, phone: string, params: RequestParams = {}) =>
    this.request<
      boolean,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/check-guest-number/${phone}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for cfLiveCheckGuestNumber */
  cfLiveCheckGuestNumberPathGetter = (tenantId: string, phone: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/check-guest-number/${phone}`);

  /**
   * @description Get live flow state
   *
   * @tags Guest, routing
   * @name GetLiveFlowState
   * @request GET:/v1/guest-external/tenant/{tenantId}/live/call-flow-state/{flowId}
   * @secure
   */
  getLiveFlowState = (tenantId: string, flowId: string, params: RequestParams = {}) =>
    this.request<
      ExternalFlowState,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/live/call-flow-state/${flowId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getLiveFlowState */
  getLiveFlowStatePathGetter = (tenantId: string, flowId: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/live/call-flow-state/${flowId}`);

  /**
   * @description Get public routing info by routingId
   *
   * @tags Guest, routing
   * @name GetPublicRoutingInfo
   * @request GET:/v1/guest-external/tenant/{tenantId}/routing/{routingId}
   * @secure
   */
  getPublicRoutingInfo = (tenantId: string, routingId: string, params: RequestParams = {}) =>
    this.request<
      PublicRoutingInfoResponse,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/routing/${routingId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getPublicRoutingInfo */
  getPublicRoutingInfoPathGetter = (tenantId: string, routingId: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/routing/${routingId}`);

  /**
   * @description Initiate scheduling step of the routing flow
   *
   * @tags Guest, routing
   * @name ScheduleMeeting
   * @request POST:/v1/guest-external/tenant/{tenantId}/routing/{routingId}/schedule
   * @secure
   */
  scheduleMeeting = (tenantId: string, routingId: string, data: ScheduleMeetingRequest, params: RequestParams = {}) =>
    this.request<
      ScheduleMeetingResult,
      | AnyDataObjectId
      | ScheduleMeetingResult
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/routing/${routingId}/schedule`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for scheduleMeeting */
  scheduleMeetingPathGetter = (tenantId: string, routingId: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/routing/${routingId}/schedule`);

  /**
   * @description List concierge routers & drafts
   *
   * @tags router
   * @name ListRouters
   * @request GET:/v1/{tenantId}/workspace/{workspaceId}/routers
   * @secure
   */
  listRouters = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      PublicConciergeDraftWithRouter[],
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/workspace/${workspaceId}/routers`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listRouters */
  listRoutersPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/${tenantId}/workspace/${workspaceId}/routers`);

  /**
   * @description Update concierge router draft
   *
   * @tags router
   * @name UpdateRouter
   * @request POST:/v1/{tenantId}/workspace/{workspaceId}/router/update
   * @secure
   */
  updateRouter = (tenantId: string, workspaceId: string, data: ConciergeRouterDraft, params: RequestParams = {}) =>
    this.request<
      void,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/workspace/${workspaceId}/router/update`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for updateRouter */
  updateRouterPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/${tenantId}/workspace/${workspaceId}/router/update`);

  /**
   * @description Publish concierge router draft changes
   *
   * @tags router
   * @name PublishRouter
   * @request POST:/v1/{tenantId}/workspace/{workspaceId}/router/publish
   * @secure
   */
  publishRouter = (
    tenantId: string,
    workspaceId: string,
    data: ExistingRouterCoordinates,
    params: RequestParams = {},
  ) =>
    this.request<
      ConciergeRouterDraft,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/workspace/${workspaceId}/router/publish`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for publishRouter */
  publishRouterPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/${tenantId}/workspace/${workspaceId}/router/publish`);

  /**
   * @description Get concierge router & draft
   *
   * @tags router
   * @name GetRouter
   * @request GET:/v1/{tenantId}/workspace/{workspaceId}/router/{routerId}
   * @secure
   */
  getRouter = (tenantId: string, workspaceId: string, routerId: string, params: RequestParams = {}) =>
    this.request<
      PublicConciergeDraftWithRouter,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/workspace/${workspaceId}/router/${routerId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getRouter */
  getRouterPathGetter = (tenantId: string, workspaceId: string, routerId: string) =>
    this.getServicePath(`/v1/${tenantId}/workspace/${workspaceId}/router/${routerId}`);

  /**
   * @description Delete concierge router & draft
   *
   * @tags router
   * @name DeleteRouter
   * @request DELETE:/v1/{tenantId}/workspace/{workspaceId}/router/{routerId}
   * @secure
   */
  deleteRouter = (tenantId: string, workspaceId: string, routerId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/workspace/${workspaceId}/router/${routerId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteRouter */
  deleteRouterPathGetter = (tenantId: string, workspaceId: string, routerId: string) =>
    this.getServicePath(`/v1/${tenantId}/workspace/${workspaceId}/router/${routerId}`);

  /**
   * @description Get concierge router & draft by id (without workspaceId)
   *
   * @tags router
   * @name GetRouterById
   * @request GET:/v1/{tenantId}/router/{routerId}
   * @secure
   */
  getRouterById = (tenantId: string, routerId: string, params: RequestParams = {}) =>
    this.request<
      PublicConciergeDraftWithRouter,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/router/${routerId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getRouterById */
  getRouterByIdPathGetter = (tenantId: string, routerId: string) =>
    this.getServicePath(`/v1/${tenantId}/router/${routerId}`);

  /**
   * @description Create concierge router draft
   *
   * @tags router
   * @name CreateRouter
   * @request POST:/v1/{tenantId}/workspace/{workspaceId}/routers/new
   * @secure
   */
  createRouter = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      ConciergeRouterDraft,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/workspace/${workspaceId}/routers/new`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createRouter */
  createRouterPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/${tenantId}/workspace/${workspaceId}/routers/new`);

  /**
   * @description Allow or forbid routing
   *
   * @tags router
   * @name AllowRouting
   * @request POST:/v1/{tenantId}/workspace/{workspaceId}/router/{routerId}/allow-routing
   * @secure
   */
  allowRouting = (
    tenantId: string,
    workspaceId: string,
    routerId: string,
    data: RoutingAcceptedState,
    params: RequestParams = {},
  ) =>
    this.request<
      ConciergeRouterDraft,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/workspace/${workspaceId}/router/${routerId}/allow-routing`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for allowRouting */
  allowRoutingPathGetter = (tenantId: string, workspaceId: string, routerId: string) =>
    this.getServicePath(`/v1/${tenantId}/workspace/${workspaceId}/router/${routerId}/allow-routing`);

  /**
   * @description Upload router cover (use the URI from response as the `router.settings.headerImage` field payload)
   *
   * @tags router
   * @name UploadCover
   * @request POST:/v1/{tenantId}/workspace/{workspaceId}/router/{routerId}/cover
   * @secure
   */
  uploadCover = (
    tenantId: string,
    workspaceId: string,
    routerId: string,
    data: CoverUploadRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      CoverUriResponse,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/workspace/${workspaceId}/router/${routerId}/cover`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for uploadCover */
  uploadCoverPathGetter = (tenantId: string, workspaceId: string, routerId: string) =>
    this.getServicePath(`/v1/${tenantId}/workspace/${workspaceId}/router/${routerId}/cover`);

  /**
   * @description Creates a copy of the router, uses existing draft as source. Doesn't publish the router even if source is published
   *
   * @tags router
   * @name DuplicateRouter
   * @request POST:/v1/{tenantId}/workspace/{workspaceId}/router/{routerId}/duplicate
   * @secure
   */
  duplicateRouter = (tenantId: string, workspaceId: string, routerId: string, params: RequestParams = {}) =>
    this.request<
      ConciergeRouterDraft,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/workspace/${workspaceId}/router/${routerId}/duplicate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for duplicateRouter */
  duplicateRouterPathGetter = (tenantId: string, workspaceId: string, routerId: string) =>
    this.getServicePath(`/v1/${tenantId}/workspace/${workspaceId}/router/${routerId}/duplicate`);

  /**
   * @description Parses form from foreign site
   *
   * @tags foreign-site
   * @name ParseForms
   * @request POST:/v1/{tenantId}/foreign-site/parse-form
   * @secure
   */
  parseForms = (tenantId: string, data: UriContainer, params: RequestParams = {}) =>
    this.request<
      ForeignForms,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/foreign-site/parse-form`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for parseForms */
  parseFormsPathGetter = (tenantId: string) => this.getServicePath(`/v1/${tenantId}/foreign-site/parse-form`);

  /**
   * @description Downloads html of the foreign site and returns it
   *
   * @tags foreign-site
   * @name GetRawPage
   * @request POST:/v1/{tenantId}/foreign-site/raw-page
   * @secure
   */
  getRawPage = (tenantId: string, data: UriContainer, params: RequestParams = {}) =>
    this.request<
      HtmlPage,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/foreign-site/raw-page`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getRawPage */
  getRawPagePathGetter = (tenantId: string) => this.getServicePath(`/v1/${tenantId}/foreign-site/raw-page`);

  /**
   * @description Retry all failed crm actions
   *
   * @tags routing
   * @name RetryAllFailedCrmActions
   * @request POST:/v1/{tenantId}/routing/retry-crm-actions
   * @secure
   */
  retryAllFailedCrmActions = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      routingId: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/routing/retry-crm-actions`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for retryAllFailedCrmActions */
  retryAllFailedCrmActionsPathGetter = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      routingId: string[];
    },
  ) => this.getServicePath(`/v1/${tenantId}/routing/retry-crm-actions`, query);

  /**
   * @description Retry failed crm action
   *
   * @tags routing
   * @name RetryFailedCrmAction
   * @request POST:/v1/{tenantId}/routing/retry-crm-action
   * @secure
   */
  retryFailedCrmAction = (
    tenantId: string,
    query: {
      /** @format uuid */
      routingId: string;
      /** @format uuid */
      actionId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/routing/retry-crm-action`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for retryFailedCrmAction */
  retryFailedCrmActionPathGetter = (
    tenantId: string,
    query: {
      /** @format uuid */
      routingId: string;
      /** @format uuid */
      actionId: string;
    },
  ) => this.getServicePath(`/v1/${tenantId}/routing/retry-crm-action`, query);

  /**
   * @description Get router logs summary
   *
   * @tags log
   * @name GetRouterLogsSummary
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/log/routers
   * @secure
   */
  getRouterLogsSummary = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /** @format date-time */
      from?: string;
      /** @format date-time */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultRouterLogSummary,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/log/routers`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getRouterLogsSummary */
  getRouterLogsSummaryPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /** @format date-time */
      from?: string;
      /** @format date-time */
      to?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/log/routers`, query);

  /**
   * @description Get all logs stats
   *
   * @tags log
   * @name GetAllLogsStats
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/log/routers/stats
   * @secure
   */
  getAllLogsStats = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /** @format date-time */
      from?: string;
      /** @format date-time */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      RouterLogStats,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/log/routers/stats`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAllLogsStats */
  getAllLogsStatsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /** @format date-time */
      from?: string;
      /** @format date-time */
      to?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/log/routers/stats`, query);

  /**
   * @description Get router logs stats
   *
   * @tags log
   * @name GetRouterLogsStats
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/log/router/{routerId}/stats
   * @secure
   */
  getRouterLogsStats = (
    tenantId: string,
    workspaceId: string,
    routerId: string,
    query: {
      /** @format date-time */
      from: string;
      /** @format date-time */
      to: string;
      assignee?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      RouterLogStats,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/log/router/${routerId}/stats`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getRouterLogsStats */
  getRouterLogsStatsPathGetter = (
    tenantId: string,
    workspaceId: string,
    routerId: string,
    query: {
      /** @format date-time */
      from: string;
      /** @format date-time */
      to: string;
      assignee?: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/log/router/${routerId}/stats`, query);

  /**
   * @description Get router log list
   *
   * @tags log
   * @name GetRouterLogsList
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/log/router/{routerId}/list
   * @secure
   */
  getRouterLogsList = (
    tenantId: string,
    workspaceId: string,
    routerId: string,
    query: {
      /** @format date-time */
      from: string;
      /** @format date-time */
      to: string;
      status?: RoutingLogStatus[];
      assignee?: string[];
      "assignment-method"?: RoutingLogAssignmentMethod[];
      trigger?: RoutingTriggerType[];
      email?: string;
      sourceUrl?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultRoutingLogHeader,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/log/router/${routerId}/list`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getRouterLogsList */
  getRouterLogsListPathGetter = (
    tenantId: string,
    workspaceId: string,
    routerId: string,
    query: {
      /** @format date-time */
      from: string;
      /** @format date-time */
      to: string;
      status?: RoutingLogStatus[];
      assignee?: string[];
      "assignment-method"?: RoutingLogAssignmentMethod[];
      trigger?: RoutingTriggerType[];
      email?: string;
      sourceUrl?: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/log/router/${routerId}/list`, query);

  /**
   * @description Get routing log
   *
   * @tags log
   * @name GetRoutingLog
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/log/routing/{routingId}
   * @secure
   */
  getRoutingLog = (tenantId: string, workspaceId: string, routingId: string, params: RequestParams = {}) =>
    this.request<
      RoutingLog,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/log/routing/${routingId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getRoutingLog */
  getRoutingLogPathGetter = (tenantId: string, workspaceId: string, routingId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/log/routing/${routingId}`);

  /**
   * @description Get billable routings count
   *
   * @tags log
   * @name GetBillableRoutingsCount
   * @request GET:/v1/tenant/{tenantId}/log/billable
   * @secure
   */
  getBillableRoutingsCount = (
    tenantId: string,
    query: {
      /** @format date-time */
      from: string;
      /** @format date-time */
      to: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      BillableRoutingLogs,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/log/billable`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getBillableRoutingsCount */
  getBillableRoutingsCountPathGetter = (
    tenantId: string,
    query: {
      /** @format date-time */
      from: string;
      /** @format date-time */
      to: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/log/billable`, query);

  /**
   * @description Export router logs
   *
   * @tags log
   * @name ExportRouterLogs
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/log/router/{routerId}/export
   * @secure
   */
  exportRouterLogs = (
    tenantId: string,
    workspaceId: string,
    routerId: string,
    query: {
      /** @format date-time */
      from: string;
      /** @format date-time */
      to: string;
      status?: RoutingLogStatus[];
      assignee?: string[];
      "assignment-method"?: RoutingLogAssignmentMethod[];
      trigger?: RoutingTriggerType[];
      email?: string;
      sourceUrl?: string[];
      timeZone?: string;
      /** There is a haproxy workaround to send all query params as headers. We use this so we can use file download api to load CSV files. If you need to update it: injectAccessTokenQueryParam function in api-client/plugin.ts. */
      access_token?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      AnyDataObjectId,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/log/router/${routerId}/export`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for exportRouterLogs */
  exportRouterLogsPathGetter = (
    tenantId: string,
    workspaceId: string,
    routerId: string,
    query: {
      /** @format date-time */
      from: string;
      /** @format date-time */
      to: string;
      status?: RoutingLogStatus[];
      assignee?: string[];
      "assignment-method"?: RoutingLogAssignmentMethod[];
      trigger?: RoutingTriggerType[];
      email?: string;
      sourceUrl?: string[];
      timeZone?: string;
      /** There is a haproxy workaround to send all query params as headers. We use this so we can use file download api to load CSV files. If you need to update it: injectAccessTokenQueryParam function in api-client/plugin.ts. */
      access_token?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/log/router/${routerId}/export`, query);
}
